import { ButtonProps } from 'antd'

import { MouseEvent } from 'react'

import { Button } from 'shared/ui/Button'
import { Spin } from 'shared/ui/Spin'

interface Props extends ButtonProps {
  isLoading?: boolean
}

export const ButtonContinue = ({
  className,
  isLoading,
  onClick: onClickAdditional,
  ...props
}: Props) => {
  const handleClickContinue = async (e: MouseEvent<HTMLElement>) => {
    if (onClickAdditional) onClickAdditional(e)
  }

  return (
    <Button
      disabled={isLoading}
      className={`h-auto max-h-[56px] py-[16px] px-[20px] text-[16px] text-white leading-[24px] font-medium bg-dark_blue_1 rounded-[16px] ${className}`}
      onClick={handleClickContinue}
      {...props}
    >
      {isLoading ? <Spin size="small" /> : 'Далее'}
    </Button>
  )
}
